angular.module('leftPaneModule')
  .controller('LeftPaneSchoolController', [
      '$scope', '$rootScope', 'schoolApi', 'cancelableResourceManager', 'authentication',
      'edxReportItemService', 'timeframe',
      function ($scope, $rootScope, $schoolApi, $cancelableResourceManager, dblAuthentication,
      edxReportItemService, timeframe) {

      var updateSchoolData = function () {
          var promise = $schoolApi.getSchoolData($scope.item.id, function (schoolData) {
              $scope.schoolData = schoolData;
              timeframe.getYearListSubject().onNext(schoolData.years);
              // deprecated: use timeframe.getYearListSubject
              $rootScope.$broadcast('updateYears', schoolData.years);
          });
          $cancelableResourceManager.add(promise);
      };

      var initializeDateTimes = function () {
          var start = new Date();
          start.setHours(8, 0, 0, 0);
          $scope.startTime = start;

          var end = new Date();

          end.setHours(16, 30, 0, 0);
          $scope.endTime = end;
      };

      var initializeData = function (item) {
          $scope.item = item;
          updateSchoolData();
          initializeDateTimes();

          $scope.viewType = dblAuthentication.growthAsFraction() ? 'fractionMode' : 'percentMode';
      };

      var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(function (item) {
          initializeData(item);
      });

      var initializeItemSettings = function (e, settingsItem) {
          $scope.schoolSettings = settingsItem;
      };
      $scope.$on('settingsItemReady', initializeItemSettings);
      $scope.$on('$destroy', function () {
          itemSubscription.dispose();
      });
  }]);
